import { render } from "./VerticalLayout.vue?vue&type=template&id=c6d7197a"
import script from "./VerticalLayout.vue?vue&type=script&lang=ts"
export * from "./VerticalLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script